import {
    RESET_RESULT,
} from '../constants/ActionTypes';
import {
    CREATE_EMAIL_REQUEST,
    CREATE_EMAIL_SUCCESS,
    CREATE_EMAIL_FAILURE,
    QUERY_EMAIL_SUCCESS,
    QUERY_EMAIL_FAILURE,
    TOGGLE_FASTPATH_SUCCESS,
    TOGGLE_FASTPATH_FAILURE,
    QUERY_FASTPATH_SUCCESS,
    QUERY_FASTPATH_FAILURE,
    LOAD_SORTED_CHANNELS_REQUEST,
    LOAD_SORTED_CHANNELS_SUCCESS,
    LOAD_SORTED_CHANNELS_FAILURE,
    SAVE_SORTED_CHANNELS_REQUEST,
    SAVE_SORTED_CHANNELS_SUCCESS,
    SAVE_SORTED_CHANNELS_FAILURE,
} from 'api/index';

const initialSettings = null;

const result = (state = initialSettings, action) => {
    switch (action.type) {
        
        case LOAD_SORTED_CHANNELS_REQUEST:
        case CREATE_EMAIL_REQUEST:
            return null;

        case SAVE_SORTED_CHANNELS_SUCCESS:
            return {
                type: 'saveSortedChannelsOk'
            }

        case QUERY_EMAIL_SUCCESS:
            return {
                type: 'queryEmail',
                payload: action.payload.results,
            }

        case QUERY_EMAIL_FAILURE:
            return null;

        case RESET_RESULT:
            return null;

        case CREATE_EMAIL_SUCCESS:
        case CREATE_EMAIL_FAILURE:
            return {
                type: 'createEmail',
                payload: action.payload,
            }

        case TOGGLE_FASTPATH_SUCCESS:
        case TOGGLE_FASTPATH_FAILURE:
            return {
                type: 'toggleFastpath',
                payload: action.payload,
            }

        case QUERY_FASTPATH_SUCCESS:
        case QUERY_FASTPATH_FAILURE:
            return {
                type: 'queryFastpath',
                payload: action.payload,
            }

        case LOAD_SORTED_CHANNELS_SUCCESS:
        case LOAD_SORTED_CHANNELS_FAILURE:
            return {
                type: 'loadSortedChannels',
                payload: action.payload,
            }
    
        default:
            return state;
    }
};

export default result;